import { render, staticRenderFns } from "./DomainSettings.vue?vue&type=template&id=7affad0f&scoped=true&"
import script from "./DomainSettings.vue?vue&type=script&lang=js&"
export * from "./DomainSettings.vue?vue&type=script&lang=js&"
import style0 from "./DomainSettings.vue?vue&type=style&index=0&id=7affad0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7affad0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
